import { Inject, Injectable } from '@angular/core';
import { ToastrService } from 'ngx-toastr';
import { DEBUG_FLAG } from './../../../app.GlobalSettings';

@Injectable()
export class MessageService {
  messages: string[] = [];
  debugFlag = false;

  constructor(private toastrService: ToastrService,
    @Inject(DEBUG_FLAG) debug: boolean) {
    // MRD - show progressbar on toast and extend timeout to 6 seconds
    this.toastrService.toastrConfig.progressBar = true;
    this.toastrService.toastrConfig.timeOut = 7000;
    this.toastrService.toastrConfig.closeButton = true;
    this.debugFlag = debug;
  }

  error(message: string, title?: string, ...optionalParams: any[]) {
    title = title || 'Error';
    if (!message || message == "") {
      console.error("MessageService.Error - Message= blank !!!!");
    }
    this.toastrService.error(message, title);
    this.log(`${title}: ${message}`, optionalParams);
  }

  info(message: string, title?: string, ...optionalParams: any[]) {
    title = title || 'Information';
    this.toastrService.info(message, title);
    this.log(`${title}: ${message}`, optionalParams);
  }

  success(message: string, title?: string, ...optionalParams: any[]) {
    title = title || 'Success';
    this.toastrService.success(message, title);
    this.log(`${title}: ${message}`, optionalParams);
  }

  warning(message: string, title?: string, ...optionalParams: any[]) {
    title = title || 'Warning';
    this.toastrService.warning(message, title);
    this.log(`${title}: ${message}`, optionalParams);
  }

  add(message: string, title?: string, ...optionalParams: any[]) {
    // TODO: this.messages.push(message);
    if (title === 'Debug' || title === 'Info') {
      // Do not log debug or info messages
      return;
    }

    if (title) {
      title = title + ': ';
    }
    this.log(`${title}${message}`, optionalParams);
  }

  clear() {
    this.messages = [];
  }

  log(message: any, ...optionalParams: any[]) {
    // tslint:disable-next-line:only-arrow-functions
    const flatten = function (arr, result = []) {
      for (let i = 0, length = arr.length; i < length; i++) {
        const value = arr[i];
        if (Array.isArray(value)) {
          flatten(value, result);
        } else {
          result.push(value);
        }
      }
      return result;
    };
    if (this.debugFlag && this.debugFlag === true) {
      const objs = flatten(optionalParams);
      if (objs.length > 0) {
        console.log(message, objs);
      }
      else {
        console.log(message);
      }
    }
  }

  public static flatten(arr, result = []) 
  {
    for (let i = 0, length = arr.length; i < length; i++) {
      const value = arr[i];
      if (Array.isArray(value)) {
        MessageService.flatten(value, result);
      } else {
        result.push(value);
      }
    }
    return result;
  };
}
